import "./cwDocument.scss";
import { Breadcrumb, Button, Col, Form, Image, Row, Steps, Tooltip } from "antd";
import CWLayout from "../cwLayout";
import { _adr } from "../../../../address";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { useEffect, useRef, useState } from "react";
import {
	ExportDocument,
	base64ToFile,
	delay,
	exportNormalFile,
	fileToformData,
	mergeSignatureWithBackground,
	urltoFile,
	validateInput,
} from "../../../../tools/tools";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useLayout } from "../../../layouts/layout";
import CWPrint from "../../printDocument/cwPrint";
import Loading from "../../../auxiliary/loader/loading";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import { Roles } from "../../../../tools/services";
import ReactSignatureCanvas from "react-signature-canvas";
import { isMobile, isTablet } from "react-device-detect";
const CWDocument = () => {
	const [t] = useTranslation("global");
	const { setLayout } = useLayout();
	const [isLoading, setIsLoading] = useState(false);
	const [isDisabled, setIsDisabled] = useState(true);

	const [frmDocument] = Form.useForm();
	const { addDocument } = useAPIPublic();
	const { changeOwner } = useDealer();

	const nav = useNavigate();
	const formData = useSelector((state) => state?.from?.changeownership);
	const dispatch = useDispatch();
	const location = useLocation();

	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});

	const [signature, setSignature] = useState(false);
	const [bgSingature, setBgSingature] = useState("");
	const [printData, setPrintData] = useState(false);
	const refBox = useRef("");

	useEffect(() => {
		setSignature(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false);
		if (!(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false)) {
			setLayout(<CWPrint print={formData} lang="fa" />);
		}
	}, []);

	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			let valid = await frmDocument.validateFields();
			if (valid) {
				// چون ممکنه چند نفر پشت سر هم رو یه کانواس امضا بزنن و سریع ثبت رو بزنن، به مقدار ذخیره‌شده تو فرم
				// (که از onEnd قبلی و async میاد) اعتماد نمی‌کنیم؛ همین لحظه دوباره با await از خودِ کانواس می‌خونیم
				let photo = valid.photo;
				if (signature) {
					const signatureCanvas = document.getElementById("canvasDoc");
					if (signatureCanvas) {
						const imgData = await mergeSignatureWithBackground(bgSingature, signatureCanvas);
						photo = await base64ToFile(imgData);
					}
				}
				let resDoc = await addDocument(await fileToformData(photo), "SWDocument");
				if (resDoc) {
					let payload = {
						// token: formData?.seller?.token,
						msisdn: formData?.seller?.msisdn,
						oldprofileinfoid: formData?.seller?.profile?.guD_ProfileInfoId,
						newprofileinfoid: formData?.buyer?.profile?.profileid,
						oldpurchaseproductid: formData?.seller?.profile?.guD_PurchaseProductId,
						// newdocumentid: formData?.buyer?.profile?.documentid,
						newdocumentid: resDoc?.Result,
						olddocumentid: formData?.seller?.documentid,
					};
					let response = await changeOwner(payload);
					if (response) {
						nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Final, {
							state: { ...response },
						});
					}
				}
			}
		} catch (error) {}
		setIsLoading(false);
	};
	const handleGetImage = async (value) => {
		frmDocument.setFieldValue("photo", value);
	};

	const handleGetCanvas = (img) => {
		setBgSingature(img);
	};

	useEffect(() => {
		const setChangeCanvas = () => {
			if (bgSingature) {
				let canvas = document.getElementById("canvasDoc");
				let parentElement = canvas.parentElement;
				canvas.width = parentElement.clientWidth;
				canvas.height = parentElement.clientHeight;
			}
		};
		setChangeCanvas();
		window.addEventListener("orientationchange", setChangeCanvas);

		return () => {
			window.removeEventListener("orientationchange", setChangeCanvas);
		};
	}, [bgSingature]);

	const clearHandler = () => {
		let canvas = document.getElementById("canvasDoc");
		let context = canvas.getContext("2d");
		context.clearRect(0, 0, canvas.width, canvas.height);
	};
	const writeSignatureHandler = async () => {
		const signatureCanvas = document.getElementById("canvasDoc");
		const imgData = await mergeSignatureWithBackground(bgSingature, signatureCanvas);
		frmDocument.setFieldValue("photo", await base64ToFile(imgData));
	};
	return (
		<CWLayout>
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.ownership.title")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className="g-body-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={4}
										items={[
											{
												title: "اطلاعات فروشنده",
											},
											{
												title: "اطلاعات خریدار",
											},
											{
												title: "آپلود مدرک شناسایی",
											},
											{
												title: "پیش فاکتور",
											},
											{
												title: "سند",
											},
										]}
									/>
								</div>
							</div>
							<div className="cw-document">
								<div className="holder-document">
									{signature ? (
										<Row>
											<Col xl={10} lg={24} style={{ margin: "auto" }}>
												<div className="holder-signature-on-document">
													<div ref={refBox} className="box-signature">
														{bgSingature?.length === 0 && <CWPrint print={formData} lang="fa" value={handleGetCanvas} canvas={true} />}
														<ReactSignatureCanvas
															penColor="blue"
															canvasProps={{
																id: "canvasDoc",
																width: "100%",
																height: "100%",
																className: "sigCanvas",
															}}
															clearOnResize={false}
															backgroundColor="transparent"
															onEnd={writeSignatureHandler}
														/>
														<img src={bgSingature} alt="" width={"100%"} />
													</div>
													<div className="holder-button">
														<Button onClick={clearHandler} className="btn-normal">
															پاک کردن
														</Button>
													</div>
												</div>
											</Col>
										</Row>
									) : (
										<>
											<div className="item-step">
												<p>1- نسبت به چاپ سند اقدام فرمایید</p>
												<Button
													className="btn-normal btn-print"
													type="default"
													icon={<i className="icon-print"></i>}
													onClick={() => {
														window.print();
														setIsDisabled(false);
													}}>
													چاپ سند
												</Button>
											</div>
										</>
									)}
									<div className="item-step" style={{ display: signature ? "none" : "block" }}>
										<p>2- فرم مهر و امضا شده را بارگذاری نمایید.</p>
										<Row gutter={20}>
											<Col span={12}>
												<Form form={frmDocument} layout="vertical">
													<Form.Item
														name="photo"
														rules={[
															{
																required: true,
																message: t("validation.required"),
															},
														]}
														label="تصویر مدرک">
														<ResizeImage disabled={isDisabled} exportImage={handleGetImage} />
													</Form.Item>
												</Form>
											</Col>
											{/* <Col span={12} style={{ margin: "auto" }}>
                          <div className="hold-text">
                            <ul>
                              <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                              <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                              <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                            </ul>
                          </div>
                        </Col> */}
										</Row>
									</div>
								</div>
							</div>
						</div>
						<div className="g-footer-format-page">
							<div className="holder-button">
								<Button className="btn-normal btn-aptel" type="primary" onClick={handleSubmit} danger>
									مرحله بعد
								</Button>
								<Button
									className="btn-normal"
									onClick={() =>
										nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Prefactor)
									}
									type="default">
									بازگشت
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</div>
			<Loading isOpen={isLoading} />
		</CWLayout>
	);
};

export default CWDocument;
